import { apiGet, apiPut } from "./client";

export interface PluginConfig {
  pluginId: string;
  name: string;
  description: string;
  enabled: boolean;
  version: string;
  installPath?: string;
}

export async function listPlugins(): Promise<PluginConfig[]> {
  const res = await apiGet<{ plugins: PluginConfig[] }>("/api/plugins");
  return res.plugins ?? [];
}

export async function getPlugin(id: string): Promise<PluginConfig> {
  const res = await apiGet<{ plugin: PluginConfig }>(`/api/plugins/${id}`);
  return res.plugin;
}

export async function togglePlugin(id: string): Promise<PluginConfig> {
  return apiPut<PluginConfig>(`/api/plugins/${id}/toggle`);
}